import React, { useEffect } from "react";
import "./Profile.css";
import ProfileDetail from "./ProfileDetails/ProfileDetails";
import ProfileImage from "src/Assets/images/ProfileImage1.png";
import { useSelector, useDispatch } from "react-redux";
import { fetchloginUser } from "../../../store/actions/SignInActions/SignInAction";

function Profile() {
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.SignInReducer.userDetails);
  let profileImagePath = process.env.REACT_APP_SKOPIC_IMAGE;

  useEffect(() => {
    setTimeout(() => {
      dispatch(fetchloginUser());
    }, 1000);
  }, []);

  return (
    <>
      <div className="Profile">
        {userDetails && Object.keys(userDetails).length !== 0 ? (
          userDetails.userData &&
          Object.keys(userDetails.userData).length !== 0 ? (
            <img
              src={
                userDetails?.userData?.communityFollowNames[0]?.thumbnailLogo
                  ? `${profileImagePath}${userDetails.userData.communityFollowNames[0].thumbnailLogo}`
                  : process.env.REACT_APP_DUMMY_COMMUNITY_IMAGE // fallback: env community image
              }
              alt="CommunityImage"
              className="Community-Image"
            />
          ) : null
        ) : null}
        <ProfileDetail />
      </div>
    </>
  );
}
export default Profile;
